import {
  useSelector,
  TypedUseSelectorHook
} from 'react-redux';
import {
  createSelector
} from '@reduxjs/toolkit';
import {
  UserRegistrationStatusEnum
} from '@shared/types';
import {
  sessionSlice,
  SessionState,
  selectKycStatus,
  UserKycStatusEnum,
  selectIsAuthenticated,
  selectRegistrationStatus,
} from '@entities/session';
import {
  type WithdrawCoinsPageState,
  withdrawCoinsPageSlice
} from './slice';

type RootState = {
  [sessionSlice.name]: SessionState;
  [withdrawCoinsPageSlice.name]: WithdrawCoinsPageState;
};

export const selectCoinRedeem = (state: RootState): number => (
  state[withdrawCoinsPageSlice.name].coinRedeem as unknown as number
);

export const useWithdrawCoinsPageSelector: TypedUseSelectorHook<RootState> = useSelector;